module.exports = __webpack_public_path__ + "static/icons/icon-mountain--bot-b112db946dc437c06c0800f9536857d6.svg";